/**
 * "Send a new code" on the forgot-password screen waits a minute after every
 * send, so the three codes an hour the server allows are not spent by
 * clicking. Pure, for the screen and its test.
 */
export const RESEND_COOLDOWN_SECONDS = 60;

/** Whole seconds left before another code may be asked for; 0 when it may be. */
export function cooldownLeft(sentAtMs, nowMs, cooldownSeconds = RESEND_COOLDOWN_SECONDS) {
    if (!Number.isFinite(sentAtMs) || !Number.isFinite(nowMs)) return 0;
    const left = Math.ceil((sentAtMs + cooldownSeconds * 1000 - nowMs) / 1000);
    return Math.min(Math.max(left, 0), cooldownSeconds);
}
